module.exports = __webpack_public_path__ + "img/huaweicce.4fb3a929.svg";